import { s3BucketName, s3BucketRegion } from './env';

export function getS3Url(): string {
  if (s3BucketRegion?.toLowerCase().includes('gov')) {
    return `https://s3-${s3BucketRegion}.amazonaws.com/${s3BucketName}`;
  }

  return `https://${s3BucketName}.s3.amazonaws.com`;
}
